export enum SigntureRequestsDeleteActionTypes {
  request = 'signature_request/DELETE_SIGNATURE_REQUESTS/REQUEST',
  success = 'signature_request/DELETE_SIGNATURE_REQUESTS/SUCCESS',
  failure = 'signature_request/DELETE_SIGNATURE_REQUESTS/FAILURE',
  cancel = 'signature_request/DELETE_SIGNATURE_REQUESTS/CANCEL',
}
